import React from 'react'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen text-zinc-100">
      <div className="max-w-6xl mx-auto p-4 sm:p-8 space-y-6">
        {children}
      </div>
    </div>
  )
}
